module.exports = __webpack_public_path__ + "media/images/history/stodulkova3-dc1a4715c1361bd06ada05760fad3c64.jpg";